// 9fbef606107a605d69c0edbcd8029e5d

export const GLOBAL_SORTING_LABELS = 'global.Sorting';

export const globalSortingLabels = {
  global: {
    Sorting: {
      lbl_TCPBazaarVoiceRating: 'Top Rated',
      lbl_favoritedcount: 'Most Favorited',
      lbl_recommended: 'Recommended',
      lbl_min_offer_price_desc: 'Price: High to Low',
      lbl_min_offer_price_asc: 'Price: Low to High',
      lbl_newest_score: 'Newest',
    },
  },
};
